import axios from "axios";
import SERVER from '@/API/url';

const UserStore = {
    namespaced: true,
    state: {
        
    },
    getters: {

    },
    mutations: {

    },
    actions: {

        // 등록확인서 PDF 생성
        registration: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/User/Registration/Confirmation', params,
                { headers: SERVER.HEADERS, responseType: 'arraybuffer' }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 참여증명서 PDF 생성
        participation: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/User/Participation/Certificate', params,
                { headers: SERVER.HEADERS, responseType: 'arraybuffer'}
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 비자신청서 PDF 생성
        visaletter: ({commit}, params) => { 
            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/VisaLetter', params,
                { headers: SERVER.HEADERS, responseType: 'arraybuffer'}
                ).then(res => {
                    // console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

    }
}

export default UserStore